export const locales = {
	supportIdMessage: 'Votre identifiant de support\xa0:',
	btnText: 'Retour à l’accueil'
};
